export default {
  // GET Requests //

  // Gets newsfeed data
  async getNewsfeedData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/newsfeed/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    response.sort(function (a, b) {
      return new Date(b.created) - new Date(a.created);
    });
    context.commit("posts", response);
    context.commit("newsfeedTimestamp");

    return 200;
  },
  // POST Requests //

  // Post on the newsfeed
  postNewsfeed(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];

    try {
      fetch(process.env.VUE_APP_NODE_SERVER + "/newsfeed/add-post", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          userId: userId,
          fullName: payload.fullName,
          content: payload.content,
          audience: payload.audience,
          locations: [payload.locationId],
          departments: [payload.departmentId],
          profilePicture: payload.profilePicture,
          type: payload.type,
        }),
      });
    } catch (err) {
      return 500;
    }

    return 201;
  },
  // Post and image newsfeed
  async postMediaNewsfeed(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];

    const fd = new FormData();
    for (let i = 0; i < payload.attachments.length; i++) {
      fd.append("file", payload.attachments[i]);
    }

    fd.append(
      "body",
      JSON.stringify({
        companyId: companyId,
        userId: userId,
        fullName: payload.fullName,
        content: payload.content,
        profilePicture: payload.profilePicture,
        audience: payload.audience,
        locations: [payload.locationId],
        departments: [payload.departmentId],
        type: payload.type,
      })
    );

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/newsfeed/add-media-post",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
    } catch (err) {
      console.log(err);
      return 500;
    }

    return 201;
  },
  // PATCH Requests //

  // Add reaction
  patchToggleReaction(context, payload) {
    const token = context.rootGetters["authData/token"];
    const userId = context.rootGetters["userData/userId"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      fetch(process.env.VUE_APP_NODE_SERVER + "/newsfeed/toggle-reaction", {
        method: "PATCH",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          postId: payload.postId,
          companyId: companyId,
          userId: userId,
          fullName: payload.fullName,
          profilePicture: payload.profilePicture,
          type: payload.type,
        }),
      });
    } catch (err) {
      return 500;
    }

    return 200;
  },
  // Add comment
  async patchAddComment(context, payload) {
    const token = context.rootGetters["authData/token"];
    const userId = context.rootGetters["userData/userId"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = fetch(
        process.env.VUE_APP_NODE_SERVER + "/newsfeed/add-comment",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            postId: payload.postId,
            userId: userId,
            companyId: companyId,
            fullName: payload.fullName,
            profilePicture: payload.profilePicture,
            type: payload.type,
            content: payload.content,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    response.status = 201;

    return response;
  },
  // Add reaction to a comment
  patchAddCommentReaction(context, payload) {
    const token = context.rootGetters["authData/token"];
    const userId = context.rootGetters["userData/userId"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/newsfeed/toggle-reaction-to-comment",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            postId: payload.postId,
            commentId: payload.commentId,
            userId: userId,
            companyId: companyId,
            fullName: payload.fullName,
            profilePicture: payload.profilePicture,
            type: payload.type,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    return 200;
  },
  // Remove comment
  patchRemoveComment(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      fetch(process.env.VUE_APP_NODE_SERVER + "/newsfeed/remove-comment", {
        method: "PATCH",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          postId: payload.postId,
          commentId: payload.commentId,
          companyId: companyId,
        }),
      });
    } catch (err) {
      return 500;
    }

    return 200;
  },
  // DELETE Requests //

  // Add reaction
  deletePost(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      fetch(process.env.VUE_APP_NODE_SERVER + "/newsfeed/remove-post", {
        method: "DELETE",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          postId: payload.postId,
          companyId: companyId,
        }),
      });
    } catch (err) {
      return 500;
    }

    return 201;
  },
  // IO Socket Mutations //

  // Add or update a post
  addPost(context, payload) {
    var posts = context.state.posts;
    let postFound = false;

    for (let i = 0; i < posts.length; i++) {
      if (posts[i]._id == payload._id) {
        posts[i] = payload;
        postFound = true;
        break;
      }
    }
    if (!postFound) {
      posts = [payload, ...posts];
    }
    context.commit("posts", posts);
  },
  // Remove the post
  removePost(context, postId) {
    var posts = context.state.posts.filter((post) => post._id != postId);
    context.commit("posts", posts);
  },
};
